import { TablePaginationConfig } from 'antd/lib/table';
import { DEFAULT_PAGINATION } from 'src/domain/commonConst';
import { IPaginationMeta } from 'src/domain/IPagination';

export function getTablePaginationParams(
    meta: IPaginationMeta | undefined,
    pagination?: false | TablePaginationConfig | undefined
): TablePaginationConfig {
    const params = {
        ...DEFAULT_PAGINATION,
        ...(meta && {
            total: meta.total,
            current: Math.ceil(meta.offset / meta.limit) + 1,
            pageSize: meta.limit,
        }),
        ...(pagination && {
            current: pagination.current,
            pageSize: pagination.pageSize,
        }),
        showSizeChanger: true,
        size: 'default',
    } as const;

    return params;
}
